var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-pay flex-wrap"},[_c('img',{attrs:{"src":require(`@/assets/images/icons/img_loading.png`),"alt":"","width":"32px"}}),_c('div',{staticClass:"title f-18 f-bold m-t-8"},[_vm._v("결제중입니다.")]),_c('div',{staticClass:"content f-14"},[_vm._v("잠시만 기다려주세요.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }